import {NO_DATA_AVAILABLE} from 'src/constants';
import {excludeNoDataAvailableValues} from 'src/utils/excludeNoDataAvailableValues';
import {possibleValuesToString} from 'src/utils/possibleValuesToString';

export const getPossibleValuesOrDefault = (possibleValues: string[]) =>
    excludeNoDataAvailableValues(possibleValues).length === 0
        ? NO_DATA_AVAILABLE
        : possibleValuesToString(possibleValues);
